<template>
    <oss-dialog
        v-model="dialog"
        :title="title"
        :previous-display="wizardStep !== 0"
        @previous="previousStep"
        :actions="actions"
        width="60vw"
    >
        <v-window v-model="wizardStep">
            <v-window-item :value="0">
                <CompaniesTable
                    v-if="wizardStep === 0"
                    :showGenericCompany="false"
                    :showNewCompanies="false"
                    :showExistingCompanies="false"
                    :showCustomerCompanies="true"
                    :showSupplierCompanies="true"
                    :showOrphelinCompanies="true"
                    :showImportCompanies="true"
                    :showSelectMergeCompanies="true"
                    :showImport="true"
                    :actions="actions"
                    :parentCompanyId="selectedCompany.id"
                    @disable-merge-button="disableMerging($event)"
                    @select-company="thirdCompanyEdit($event)"
                    @companies-to-merge="thirdCompaniesMerge($event)"
                    @import-companies="importCompanies($event)"
                    @emit-actions="setActions()"
                />
            </v-window-item>
            <v-window-item :value="1">
                <ThirdPartyCompanyEdition
                    v-if="wizardStep === 1"
                    :showEditCompany="true"
                    :showCompanyContacts="true"
                    :showCompanyIBANS="true"
                    :showCompanyProducts="showProductsTab"
                    :showTagRules="true"
                    :thirdPartyCompanyId="thirdPartyCompany.id"
                    :thirdPartyCompanyType="thirdPartyCompany.thirdPartyCompanyType"
                    :companyId="selectedCompany.id"
                    :actions="actions"
                    @iban-rules="setCreateIbanValid($event)"
                    @create-user="setCreateUserValid($event)"
                    @active-tab="setActiveTab($event)"
                    @step="setStepFromChild($event)"
                    @edit-mode="setEditMode($event)"
                    @upsertDone="wizardStep = 0"
                    ref="thirdPartyCompanyEditionIndex"
                />
            </v-window-item>
            <v-window-item :value="2">
                <MergeCompanies
                    v-if="wizardStep === 2"
                    :tpCompaniesIdToMerge="tpCompaniesIdToMerge"
                    :actions="actions"
                    ref="mergeCompanyIndex"
                    @merge-done="previousStep()"
                />
            </v-window-item>
            <v-window-item :value="3">
                <CompaniesImport
                    v-if="wizardStep === 3"
                    ref="importComponent"
                    :actions="actions"
                    :documentType="'CHILD_COMPANIES'"
                    :selectedCompanyId="selectedCompany.id"
                    @documentImported="onDocumentImported()"
                    @back="wizardStep = 0"
                />
            </v-window-item>
        </v-window>
    </oss-dialog>
</template>

<script lang="ts">
import CompaniesTable from "./admin/CompaniesTable.vue";
import MergeCompaniesComp, { MergeCompanies } from "./MergeCompanies.vue";
import CompaniesImportComp, { CompaniesImport } from "./import/CompaniesImport.vue";
import { DialogAction } from "../services/dialogAction";
import { Component, Ref, Vue, toNative } from "vue-facing-decorator";
import { Model, Watch } from "vue-facing-decorator";
import ThirdPartyCompanyEditionComp, {
    ThirdPartyCompanyEdition,
} from "./ThirdPartyCompanyEdition.vue";
import { checkAccessRights } from "../services/accessRightServices";
import { User } from "../store/store";
@Component({
    components: {
        CompaniesTable,
        MergeCompanies: MergeCompaniesComp,
        ThirdPartyCompanyEdition: ThirdPartyCompanyEditionComp,
        CompaniesImport: CompaniesImportComp,
    },
    emits: ["refresh"],
})
export class ThirdPartyCompanies extends Vue {
    @Model({ default: false }) value: boolean;
    wizardStep = 0;
    loading = false;
    mergeLoading = false;
    activeTab = "";
    editMode = false;
    deleteMode = false;
    stepFromChild = "default";
    activateToMergeCompanies = true;
    ibanRulesValid = false;
    createUserValid = false;
    createIbanValid = false;
    thirdPartyCompany: any = "";
    tpCompaniesIdToMerge = [];

    newIban = {
        iban: "",
        default: true,
    };

    actions = {
        action: new DialogAction(),
    };

    get currentUser(): User {
        return this.$store.state.user;
    }

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        this.value = event;
    }

    get title() {
        let title = "Edition des Clients / Fournisseurs";
        if (this.wizardStep === 3) {
            title = "Importer des dossiers";
        }
        return title;
    }

    beforeMount() {
        this.setActions();
    }

    setIbanRulesOK(rules: boolean) {
        this.ibanRulesValid = rules;
    }

    setCreateUserValid(createData: boolean) {
        this.createUserValid = createData;
    }

    setCreateIbanValid(createData: boolean) {
        this.createIbanValid = createData;
    }

    setActiveTab(activeTab: string) {
        this.activeTab = activeTab;
    }

    setStepFromChild(step: string) {
        this.stepFromChild = step;
    }

    setEditMode(editMode: boolean) {
        if (!(this.activeTab === "EditCompany")) {
            this.editMode = editMode;
        }
    }

    changeEditMode() {
        if (!(this.activeTab === "EditCompany")) {
            this.editMode = false;
        }
    }

    get disabledValue() {
        debugger;
        switch (this.activeTab) {
            case "EditCompany": {
                return false;
            }
            case "CompanyContacts": {
                return !this.createUserValid;
            }
            case "CompanyIBANS": {
                return !this.createIbanValid;
            }
        }

        return true;
    }

    get hideValid() {
        switch (this.activeTab) {
            case "EditCompany": {
                return false;
            }
            case "CompanyContacts": {
                if (!(this.stepFromChild === "createUser")) {
                    return true;
                } else {
                    return false;
                }
            }
            case "CompanyIBANS": {
                if (!(this.stepFromChild === "createIban")) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        return true;
    }

    @Ref("thirdPartyCompanyEditionIndex") thirdPartyCompanyEditionIndex!: ThirdPartyCompanyEdition;
    previousStep() {
        switch (this.wizardStep) {
            case 0: {
                break;
            }
            case 1: {
                debugger;
                if (this.activeTab === "CompanyContacts" && this.stepFromChild === "createUser") {
                    this.editMode = false;

                    this.thirdPartyCompanyEditionIndex.changeStep();
                    this.thirdPartyCompanyEditionIndex.clearTextField();
                } else if (
                    this.activeTab === "CompanyContacts" &&
                    this.stepFromChild === "default"
                ) {
                    this.wizardStep = 0;
                    this.thirdPartyCompanyEditionIndex.clearTextField();
                } else if (
                    this.activeTab === "CompanyIBANS" &&
                    this.stepFromChild === "createIban"
                ) {
                    this.editMode = false;
                    this.thirdPartyCompanyEditionIndex.changeStep();
                    this.thirdPartyCompanyEditionIndex.clearTextField();
                } else if (this.activeTab === "CompanyIBANS" && this.stepFromChild === "default") {
                    this.wizardStep = 0;
                } else if (this.activeTab === "EditCompany" && this.stepFromChild === "default") {
                    this.wizardStep = 0;
                }
                break;
            }
            case 2: {
                this.wizardStep = 0;
                break;
            }
            case 3: {
                break;
            }
        }
    }

    async thirdPartyCompanyEdit() {
        await this.thirdPartyCompanyEditionIndex.updateThirdPartyCompany();
    }

    updateThirdPartyCompanyInfo() {
        if (this.activeTab === "EditCompany") {
            this.wizardStep = 0;
        }
    }

    @Ref("mergeCompanyIndex") mergeCompanyIndex!: MergeCompanies;
    async mergeThirdPartyCompany() {
        this.mergeLoading = true;
        await this.mergeCompanyIndex.companiesMerge();
        this.dialog = false;
        this.mergeLoading = false;
        this.wizardStep = 0;
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    thirdCompanyEdit(company) {
        this.thirdPartyCompany = company;
        this.wizardStep = 1;
    }

    thirdCompaniesMerge(companies) {
        this.tpCompaniesIdToMerge = companies;
        if (companies.length > 1) {
            this.activateToMergeCompanies = false;
        } else if (companies.length <= 1) {
            this.activateToMergeCompanies = true;
        }
    }

    disableMerging(event) {
        if (event) {
            this.activateToMergeCompanies = true;
        } else {
            this.activateToMergeCompanies = false;
        }
    }

    importCompanies(event) {
        if (event) {
            this.activateToMergeCompanies = true;
            this.wizardStep = 3;
        }
    }

    onDocumentImported() {
        this.wizardStep = 0;
        this.$emit("refresh");
    }

    get showProductsTab() {
        const authorized = checkAccessRights(
            this.currentUser,
            "stock",
            "read",
            true,
            "isAllowedToStock",
        );

        return authorized && this.selectedCompany?.profile?.stock;
    }

    @Ref("importComponent")
    importComponent!: CompaniesImport;
    @Watch("wizardStep")
    setActions() {
        if (this.wizardStep === 0) {
            if (this.actions?.action) {
                this.actions.action.function = () => {
                    this.wizardStep = 2;
                };
                this.actions.action.disabled = () => {
                    return !!this.activateToMergeCompanies;
                };
                this.actions.action.title = "Fusionner";
                this.actions.action.previous = () => {
                    this.wizardStep = 0;
                };
            }
        }
        if (this.wizardStep === 3) {
            if (this.importComponent) {
                this.importComponent.setActionsButton();
            }
        }
    }
}

export default toNative(ThirdPartyCompanies);
</script>
